export default __webpack_public_path__ + "static/media/filmage-home-placeholder.617f6ddb.jpg";